import {createStore} from "effector";

export const $lotsList = createStore({count: 0, data: []})

export const $selectedLot = createStore({})